'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var imageLayout = require('./imageLayout');
var ImageLoader = require('./imageLoader');

var TIMEOUT = 250;

function wixImageWrapper(WixElement, services, environmentConsts) {
    if (!services.imageLoader) {
        services.imageLoader = new ImageLoader(services.mutationService);
    }

    var WixImage = function (_WixElement) {
        _inherits(WixImage, _WixElement);

        function WixImage() {
            _classCallCheck(this, WixImage);

            // eslint-disable-line no-useless-constructor
            return _possibleConstructorReturn(this, _WixElement.call(this));
        }

        WixImage.prototype.reLayout = function reLayout() {
            var domNodes = {};
            var measures = {};

            var imageId = this.getAttribute('id');
            var imageInfo = JSON.parse(this.dataset.imageInfo);
            domNodes[imageId] = this;
            domNodes[imageInfo.containerId] = document.querySelector('#' + imageInfo.containerId);

            var patchImage = function patchImage(loadImage) {
                services.mutationService.mutate(function () {
                    imageLayout.patch(imageId, measures, domNodes, imageInfo.imageData, imageInfo.alignType, services, environmentConsts, loadImage);
                });
            };

            services.mutationService.measure(function () {
                imageLayout.measure(imageId, measures, domNodes, imageInfo.containerId);
            });

            if (!this.firstRun) {
                this.firstRun = true;
                patchImage(true);
            } else {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(function () {
                    patchImage(true);
                }, TIMEOUT);

                patchImage(false);
            }
        };

        WixImage.prototype.attributeChangedCallback = function attributeChangedCallback(name, oldValue) {
            if (oldValue) {
                this.reLayout();
            }
        };

        WixImage.prototype.disconnectedCallback = function disconnectedCallback() {
            _WixElement.prototype.disconnectedCallback.call(this);
            services.imageLoader.onImageDisconnected(this);
        };

        _createClass(WixImage, null, [{
            key: 'observedAttributes',
            get: function get() {
                return ['data-image-info'];
            }
        }]);

        return WixImage;
    }(WixElement);

    return WixImage;
}

module.exports = wixImageWrapper;
//# sourceMappingURL=wixImage.js.map